var klevuCore = document.createElement('script');
klevuCore.src = 'https://js.klevu.com/core/v2/klevu.js';
document.head.appendChild(klevuCore);

klevuCore.addEventListener('load', () => {
    // quick search-theme.liquid
    klevu.interactive(function () {
        var searchBoxSelector = 'input.search-form__input';
        var searchBoxSelectorDawn = 'input.search__input';
        if (null !== document.querySelector(searchBoxSelectorDawn)) {
            searchBoxSelector = searchBoxSelectorDawn;
        }

        var options = {
            url : {
                landing: '/pages/search-results', // your Shopify Search Results Page
                search: klevu.settings.url.protocol + '//uscs32v2.ksearchnet.com/cs/v2/search' // your Klevu APIv2 Search URL
            },
            search: {
                minChars: 0,
                searchBoxSelector: searchBoxSelector + ',.kuSearchInput,input[name=q]', // your Shopify Search Input
                apiKey: "klevu-169289950810516675" // your Klevu JS API Key
            },
            analytics: {
                apiKey: 'klevu-169289950810516675' // your Klevu JS API Key
            }
        };

        var documentClickPreventSelectors = [];
        if (document.querySelector('.modal-overlay')) {
            documentClickPreventSelectors.push('.modal-overlay');
        }
        if (document.querySelector('.modal__toggle-open')) {
            documentClickPreventSelectors.push('.modal__toggle-open');
        }
        if (documentClickPreventSelectors.length > 0) {
            options.search.documentClickPreventSelector = documentClickPreventSelectors.join(',');
        }

        klevu(options);
    });

    var klevuQuickSearchTHeme = document.createElement('script');
    klevuQuickSearchTHeme.src = 'https://js.klevu.com/theme/default/v2/quick-search-theme.js';
    document.head.appendChild(klevuQuickSearchTHeme);
    
    if(window.location.href.includes('/pages/search-results')){
        var klevuCoreN = document.createElement('script');
        klevuCoreN.src = 'https://js.klevu.com/theme/default/v2/landing-page-theme.js';
        document.body.appendChild(klevuCoreN);
    }

});